import {gql} from '@apollo/client';

export const FullGroup = gql`
    fragment FullGroup on Group {
        description
        id
        institutionId
        site {
            ...InstitutionSet
        }
        profileImage {
            ...ProfileImage
        }
        staffRatio
        title
        ordering
    }
`;
